/**
 * Date string constants for moment library
 */ export var MomentConstants = /*#__PURE__*/ function(MomentConstants) {
    MomentConstants["Second"] = "second";
    MomentConstants["Minute"] = "minute";
    MomentConstants["Hour"] = "hour";
    MomentConstants["Day"] = "day";
    MomentConstants["Week"] = "week";
    MomentConstants["Month"] = "month";
    MomentConstants["Year"] = "year";
    return MomentConstants;
}({});
/**
 * Different categories of due dates on tasks
 */ export var DueDateCategory = /*#__PURE__*/ function(DueDateCategory) {
    /** Late */ DueDateCategory[DueDateCategory["Late"] = 0] = "Late";
    /** Due today */ DueDateCategory[DueDateCategory["Today"] = 1] = "Today";
    /* Due Tomorrow */ DueDateCategory[DueDateCategory["Tomorrow"] = 2] = "Tomorrow";
    /** Due in the current calendar week */ DueDateCategory[DueDateCategory["ThisWeek"] = 3] = "ThisWeek";
    /** Due in the next calendar week */ DueDateCategory[DueDateCategory["NextWeek"] = 4] = "NextWeek";
    /** Due later than the next calendar week */ DueDateCategory[DueDateCategory["Future"] = 5] = "Future";
    /** No due date set */ DueDateCategory[DueDateCategory["NoDate"] = 6] = "NoDate";
    /** Some due date  */ DueDateCategory[DueDateCategory["SomeDate"] = 7] = "SomeDate";
    return DueDateCategory;
}({});
/** Every relative-date token a date filter value may carry. */ export var RelativeDateToken = /*#__PURE__*/ function(RelativeDateToken) {
    RelativeDateToken["Late"] = "late";
    RelativeDateToken["Today"] = "today";
    RelativeDateToken["Tomorrow"] = "tomorrow";
    RelativeDateToken["ThisWeek"] = "thisWeek";
    RelativeDateToken["NextWeek"] = "nextWeek";
    RelativeDateToken["Future"] = "future";
    return RelativeDateToken;
}({});
/**
 * Date categories shown in the task filter menu.
 * Excludes SomeDate, which is not used in the main filter menu.
 */ export const FilterMenuDateCategories = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];
/**
 * Enumeration of the different days of the week
 */ export var DayOfWeek = /*#__PURE__*/ function(DayOfWeek) {
    DayOfWeek["Monday"] = "monday";
    DayOfWeek["Tuesday"] = "tuesday";
    DayOfWeek["Wednesday"] = "wednesday";
    DayOfWeek["Thursday"] = "thursday";
    DayOfWeek["Friday"] = "friday";
    DayOfWeek["Saturday"] = "saturday";
    DayOfWeek["Sunday"] = "sunday";
    return DayOfWeek;
}({});
/**
 * Enumeration of the different relative weeks in the month when representing a day relative to the weeks in a month
 * E.g. first Monday, second Tuesday, last Thursday etc.
 */ export var RelativeWeekIndex = /*#__PURE__*/ function(RelativeWeekIndex) {
    RelativeWeekIndex["First"] = "first";
    RelativeWeekIndex["Second"] = "second";
    RelativeWeekIndex["Third"] = "third";
    RelativeWeekIndex["Fourth"] = "fourth";
    RelativeWeekIndex["Last"] = "last";
    return RelativeWeekIndex;
}({});
/** Number of milliseconds in a single day (24 * 60 * 60 * 1000) */ export const MillisecondsPerDay = 24 * 60 * 60 * 1000;
/** Number of milliseconds in seven days (one week) */ export const SevenDaysInMilliseconds = 7 * MillisecondsPerDay;
